export default {"src":"/login-app/[GIT_HASH]/_next/static/media/column_lineage.f6e1ee90.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};